import React, { useState, useRef, useEffect } from 'react'
import Modal from 'react-modal'
import MessageUI from '../output/MessageUI'
import './Modal.css'

const ModalUI = ({
  context,
  messageList,
  titleMessageKey,
  titleLabel,
  isOpen,
  children,
  onAfterOpen,
  onRequestClose
}) => {
  // Simple drag state for the modal content
  const [position, setPosition] = useState({ x: 0, y: 0 })
  const modalContentRef = useRef(null)
  const dragStateRef = useRef({
    isDragging: false,
    startX: 0,
    startY: 0,
    originX: 0,
    originY: 0
  })

  const handleMouseDown = (event) => {
    // Start dragging only with primary mouse button
    if (event.button !== 0) return
    event.preventDefault()
    dragStateRef.current = {
      isDragging: true,
      startX: event.clientX,
      startY: event.clientY,
      originX: position.x,
      originY: position.y
    }
  }

  useEffect(() => {
    const handleMouseMove = (event) => {
      if (!dragStateRef.current.isDragging) return
      const dx = event.clientX - dragStateRef.current.startX
      const dy = event.clientY - dragStateRef.current.startY
      const newX = dragStateRef.current.originX + dx
      const newY = dragStateRef.current.originY + dy
      setPosition({ x: newX, y: newY })
      
      // Apply transform directly to the modal content element
      if (modalContentRef.current) {
        modalContentRef.current.style.transform = `translate(calc(-50% + ${newX}px), calc(-50% + ${newY}px))`
      }
    }

    const handleMouseUp = () => {
      if (dragStateRef.current.isDragging) {
        dragStateRef.current.isDragging = false
      }
    }

    window.addEventListener('mousemove', handleMouseMove)
    window.addEventListener('mouseup', handleMouseUp)

    return () => {
      window.removeEventListener('mousemove', handleMouseMove)
      window.removeEventListener('mouseup', handleMouseUp)
    }
  }, [])

  // Reset position when modal closes
  useEffect(() => {
    if (!isOpen) {
      setPosition({ x: 0, y: 0 })
      if (modalContentRef.current) {
        modalContentRef.current.style.transform = 'translate(-50%, -50%)'
      }
    }
  }, [isOpen])

  return (
    <Modal
      isOpen={isOpen}
      className='w_modal'
      overlayClassName='w_modal_overlay'
      onAfterOpen={onAfterOpen}
      onRequestClose={onRequestClose}
      contentRef={node => modalContentRef.current = node}
    >
      <div
        className='header g_flex_h'
        onMouseDown={handleMouseDown}
        style={{ cursor: 'move' }}
      >
        <MessageUI
          label={titleLabel}
          messageList={messageList}
          messageKey={titleMessageKey}
        />
        <div className='icon icon-times' onClick={onRequestClose}></div>
      </div>

      <div className='body'>{children}</div>
    </Modal>
  )
}

export default ModalUI
